import { styled } from '@mui/material';
import Chip from '@mui/material/Chip';

const StyledChip = styled(Chip)(({ theme }) => ({
  background: theme.palette.createBrandGradients.brand({
    color1: theme.palette.primary['800'],
    color2: theme.palette.primary['700'],
    deg: 26.5,
  }),
  color: theme.palette.common.white,
}));

export default StyledChip;
